import { ReactElement, useState } from 'react';
import AIModal, { AI_MODAL_TYPE } from '../aiModal';
import Colors from '@domain/constant/colors';

import classnames from 'classnames/bind';
import styles from '../introduce.module.scss';
const cx = classnames.bind(styles);

const Arrow = () => {
  return (
    <svg
      className={cx('arrowWrap')}
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.489844 12.5544C0.270344 12.7629 0.261447 13.1099 0.469972 13.3294C0.678497 13.5489 1.02548 13.5578 1.24498 13.3492L7.50696 7.40036C7.51118 7.39641 7.51536 7.39237 7.51948 7.38826C7.62663 7.28155 7.68064 7.14091 7.68066 7C7.68068 6.91898 7.66284 6.83788 7.62699 6.76309C7.60073 6.70825 7.56488 6.65695 7.51948 6.61174C7.51536 6.60763 7.51118 6.60359 7.50696 6.59964L1.24498 0.650753C1.02548 0.44223 0.678498 0.451126 0.469973 0.670626C0.261449 0.890127 0.270345 1.23711 0.489845 1.44563L6.33655 7L0.489844 12.5544Z"
        fill={Colors.C_COOL_GRAY_70}
      />
    </svg>
  );
};

interface AICardProps {
  type: AI_MODAL_TYPE;
  desc: string;
  title: string | ReactElement;
  imgUrl: string;
  onClick: () => void;
  onClose: () => void;
  visible: boolean;
}

const AICard = ({ type, desc, title, imgUrl, onClick, onClose, visible }: AICardProps) => {
  return (
    <div className={cx('aiCard')} onClick={onClick}>
      <img className={cx('aiCardImg')} src={imgUrl} />
      <div className={cx('aiCardContentsWrap')}>
        <span className={cx('aiCardDesc')}>{desc}</span>
        <div className={cx('aiCardTitleWrap')}>
          <span className={cx('aiCardTitle')}>{title}</span>
        </div>
        <a className={cx('aiCardLink')}>
          자세히보기
          <Arrow />
        </a>
      </div>
      <AIModal type={type} visible={visible} onClose={onClose} />
    </div>
  );
};

const AI = () => {
  const [modalType, setModalType] = useState<AI_MODAL_TYPE | null>(null);

  const getVisible = (type: AI_MODAL_TYPE) => type === modalType;

  const handleOnClick = (type: AI_MODAL_TYPE) => {
    setModalType(type);
  };

  const handleOnClose = () => {
    setModalType(null);
  };

  return (
    <div className={cx('contents')}>
      <div className={cx('titleWrap')}>
        <span className={cx('title')}>
          <span className={cx('textEmphasis')}>역검</span>으로
          <br />알 수 있습니다
        </span>
      </div>
      <div className={cx('aiCardWrap')}>
        <div className={cx('aiCardsLeft')}>
          <AICard
            type={'DIFFERENCE'}
            desc={'역검만의 차별점'}
            title={(
              <>
                역검은 성과, 가치, 관계를
                <br />
                통합적으로 분석합니다.
              </>
            )}
            imgUrl={'/img/acc/introduce/imgAI01.png'}
            onClick={() => handleOnClick('DIFFERENCE')}
            onClose={handleOnClose}
            visible={getVisible('DIFFERENCE')}
          />
          <AICard
            type={'SUCCESS'}
            desc={'성공의 시작은 무엇일까요?'}
            title={(
              <>
                성공경험의 첫 시작, 나만의
                <br />
                역량을 객관적으로 아는 것입니다.
              </>
            )}
            imgUrl={'/img/acc/introduce/imgAI02.png '}
            onClick={() => handleOnClick('SUCCESS')}
            onClose={handleOnClose}
            visible={getVisible('SUCCESS')}
          />
        </div>
        <div className={cx('aiCardsRight')}>
          <AICard
            type={'WHY'}
            desc={'역량을 아는 것은 왜 중요할까요?'}
            title={(
              <>
                우리의 성과를 만드는 힘은
                <br />
                역량이기 때문입니다.
              </>
            )}
            imgUrl={'/img/acc/introduce/imgAI03.png'}
            onClick={() => handleOnClick('WHY')}
            onClose={handleOnClose}
            visible={getVisible('WHY')}
          />
          <AICard
            type={'EVOLUTION'}
            desc={'역검 리포트 어떻게 진화할까요?'}
            title={(
              <>
                나만의 역량을 강화할 수 있는
                <br />
                역량 함양 프로그램을 제공합니다.
              </>
            )}
            imgUrl={'/img/acc/introduce/imgAI04.png'}
            onClick={() => handleOnClick('EVOLUTION')}
            onClose={handleOnClose}
            visible={getVisible('EVOLUTION')}
          />
        </div>
      </div>
    </div>
  );
};

export default AI;
